const languages = ['CZ', 'EN', 'RU'];

export { languages };
